import React, { Component, useState } from "react";
import {
  Form,
  Row,
  Col,
  Button,
  Carousel,
  CarouselItem,
  Modal,
} from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
export class NewsLetter extends Component {
  render() {
    return (
      <div>
        <section id="contact" style={{ backgroundColor: "#004767" }}>
          <div class="container">
            <div >
              <div class="section-header">
                <h3
                  style={{
                    color: "#fff",
                    alignContent: "center",
                    fontSize: 28,
                    justifyContent: "center",
                    alignSelf: "center",
                    fontWeight: 500,
                    paddingTop: 12,
                  }}
                >
                  Newsletter
                </h3>
                <p
                  style={{
                    color: "#fff",
                    alignContent: "center",
                    fontSize: 16,
                    justifyContent: "center",
                    alignSelf: "center",
                    fontWeight: 600,
                  }}
                >
                  Get data-based reports and unique insights on private
                  companies and trends.
                </p>
                <br />
                <div>
                  <Form>
                    <Form.Group
                      as={Row}
                      controlId="formPlaintextEmail"
                      style={{
                        alignContent: "center",

                        justifyContent: "center",
                        alignSelf: "center",
                      }}
                    >
                      <Col sm="4">
                        <input
                          type="text"
                          class="form-control"
                          id="exampleInputEmail1"
                          aria-describedby="emailHelp"
                          placeholder="Full Name"
                          style={{ color: "#004767" }}
                        />
                      </Col>
                      <Col sm="4">
                        <PhoneInput
                          className="col-sm-4"
                          country={"in"}
                          inputStyle={{ color: "#004767" }}
                          // value={this.state.phone}
                          // onChange={(phone) => this.setState({ phone })}
                          style={{ color: "#004767" }}
                        />
                      </Col>
                      <Col sm="4">
                       

                        <div class="input-group mb-3">
  <input type="text" class="form-control" placeholder="Email Id" aria-label="Recipient's username" aria-describedby="basic-addon2"></input>
  <div class="input-group-append">
    <button class="btn btn-outline-success" type="button">Subscribe</button>
  </div>
</div>
                      </Col>
                     
                    </Form.Group>
                    <div style={{paddingLeft:20}}>
                    <input
                          type="checkbox"
                          class="form-check-input"
                          id="exampleCheck1" 
                        />
                        <label
                          class="form-check-label"
                          for="exampleCheck1"
                          style={{
                            fontSize: 12,
                            fontWeight: 500,
                            color: "#FFF",
                          }}
                        >
                          I agree to the Disclaimers, Disclosure, Terms and
                          Conditions and Privacy Policy
                        </label>
                        
                        
                     
                        </div>
                   
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default NewsLetter;
